@if (isPageActive()) {
<div class="fdx-o-grid fdx-o-grid--max-width">
  <app-page-header [title]="'Teraz możesz nadać Twoją paczkę w punkcie'">
  </app-page-header>

  <!-- <div class="fdx-o-grid__row fdx-o-grid__row--center">
    <img [src]="'assets/images/mapka.png'" alt="" width="100%" height="200" />
  </div> -->

  <div class="fdx-o-grid__item fdx-u-align--center">
    <p class="fdx-c-heading fdx-c-heading--h4 fdx-c-heading--bold fdx-u-mt--5">
      <!-- STOKROTKA -->
      {{ storeService.getShippingPointFormData()?.pointPartner }}
    </p>
    <p class="fdx-c-heading fdx-c-heading--h4 fdx-c-heading--bold fdx-u-mt--5">
      <!-- Górczewska 158, Warszawa, 01-460 -->
      {{ storeService.getShippingPointFormData()?.pointAddress }}
      <br />
      {{ storeService.getShippingPointFormData()?.pointZipCode }}
      {{ storeService.getShippingPointFormData()?.pointCity }}
    </p>
    <p class="fdx-c-heading fdx-c-heading--h4 fdx-u-mt--5 fdx-u-mb--5">
      {{ getPointWorkingHours() }}
    </p>

    @if ( this.storeService.getSender() !== undefined ) {
    <div class="fdx-o-grid__row fdx-u-mb--10 fdx-u-mt--10 fdx-u-px--4">
      <div
        class="fdx-o-grid__item fdx-o-grid__row--center fdx-u-align--center fdx-o-grid__item--center fdx-o-grid__item--12 fdx-o-grid__item--1@large fdx-o-grid__item--1@medium">
        <svg
          width="64"
          height="64"
          viewBox="0 0 128 128"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.1878 15.6598C55.6192 15.44 56.1301 15.442 56.5599 15.6651L101.072 38.777C101.569 39.0351 101.881 39.5484 101.881 40.1083V64.9963C101.881 65.8248 101.209 66.4963 100.381 66.4963C99.5526 66.4963 98.881 65.8248 98.881 64.9963V42.6181L57.367 64.9715V105.353L58.8534 104.643C59.6008 104.286 60.4964 104.602 60.8536 105.349C61.2108 106.097 60.8945 106.992 60.1471 107.35L56.5155 109.085C56.2176 109.228 55.8847 109.266 55.5682 109.202C55.4207 109.172 55.2809 109.12 55.1525 109.051L9.81936 85.9567C9.31672 85.7007 9.00024 85.1843 9.00024 84.6202V40.1083C9.00024 39.5442 9.31673 39.0278 9.81936 38.7717L55.1878 15.6598ZM55.8621 18.6831L97.1709 40.1317L93.3478 42.1902L51.1421 21.0876L55.8621 18.6831ZM47.8193 22.7803L21.4293 36.2241L36.6888 44.1472L62.0821 29.9117L47.8193 22.7803ZM65.3249 31.533L39.8738 45.8009L43.8014 47.8402L68.9643 33.3527L65.3249 31.533ZM72.1822 34.9617L46.9628 49.4817L63.6831 58.1633L90.1179 43.9294L72.1822 34.9617ZM18.3684 38.0151L60.4872 59.8842L55.8672 62.3719L14.1723 39.9211L18.1642 37.8875C18.2277 37.9347 18.2959 37.9774 18.3684 38.0151ZM12.0002 42.1588L54.367 64.9714V105.284L12.0002 83.7009V42.1588Z"
            fill="#4D148C" />
          <path
            d="M87.8819 105.591C88.4811 106.191 89.1659 106.447 90.1075 106.447C91.0491 106.447 91.8195 106.191 92.4187 105.591C93.0179 104.992 93.2747 104.222 93.2747 103.366C93.2747 102.51 93.0179 101.825 92.4187 101.226C91.8195 100.627 91.0491 100.37 90.1075 100.37C89.2515 100.37 88.4811 100.627 87.8819 101.226C87.2827 101.739 87.0259 102.51 87.0259 103.366C87.0259 104.307 87.2827 104.992 87.8819 105.591Z"
            fill="#4D148C" />
          <path
            d="M87.9675 97.3738H92.2475L92.7611 78.1995H87.5395L87.9675 97.3738Z"
            fill="#4D148C" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M90.108 60.4358C90.6563 60.4358 91.1609 60.7349 91.424 61.2159L118.816 111.292C119.07 111.757 119.061 112.321 118.791 112.777C118.52 113.232 118.03 113.512 117.5 113.512H62.7158C62.186 113.512 61.6956 113.232 61.4254 112.777C61.1553 112.321 61.1456 111.757 61.3998 111.292L88.792 61.2159C89.0551 60.7349 89.5597 60.4358 90.108 60.4358ZM114.97 110.512L90.108 65.0614L65.246 110.512H114.97Z"
            fill="#4D148C" />
        </svg>
      </div>
      <div
        class="fdx-o-grid__item fdx-o-grid__item--12 fdx-o-grid__item--10@large fdx-o-grid__item--10@medium fdx-u-px--4 fdx-o-grid__row--center fdx-u-align--center"
        style="border: 2px solid #4d148c">
        <p
          class="fdx-c-paragraph fdx-c-paragraph--bold fdx-c-paragraph--regular">
          Gotową etykietę umieść na płaskiej i górnej powierzchni oraz upewnij
          się, że jest widoczna.
        </p>
        <p class="fdx-c-paragraph fdx-c-paragraph--regular">
          Jeśli nie masz możliwości wydruku etykiety, przepisz wyraźnie numer
          listu przewozowego<br />na Twoją przesyłkę i nadaj ją w wybranym
          Punkcie Partnerskim FedEx.
        </p>
      </div>
    </div>
    }

    <a [href]="mapUrl" target="_blank" rel="noopener noreferrer">
      <div
        class="fdx-c-button fdx-c-button--text"
        style="margin: 0px; padding: 0px">
        <span class="fdx-c-heading fdx-c-heading--h4 fdx-c-heading--bold">
          UZYSKAJ WSKAZÓWKI</span
        >
      </div>
    </a>
    @if (this.storeService.getSender() === undefined) {
    <div class="fdx-o-grid__row fdx-o-grid__row--center">
      <div
        class="fdx-c-button fdx-c-button--text"
        style="margin: 0px; padding: 0px"
        (click)="getLabel()">
        <span class="fdx-c-heading fdx-c-heading--h4 fdx-c-heading--bold">
          POBIERZ LIST</span
        >
      </div>
    </div>
    }
  </div>
</div>
<div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--5">
  <app-back-button
    [isLoading]="false"
    [isDisabled]="false"
    [buttonText]="'ZMIEŃ'"
    (clickEvent)="changePointButtonAction()">
  </app-back-button>
</div>
}
